<script lang="ts">
    import {Flex} from 'shared/layouts';
    import {KpUserAvatar} from 'shared/components/kp-user-avatar';
    import type {GridField} from 'src/features/record-grid/lib/types';
    import {getTextFromGridFieldValue} from 'src/features/erp-sutor/sutor-utils';
    import GridFieldValue from 'shared/ui-widgets/grid/GridFieldValue.svelte';

    export let workerField: GridField | null;
</script>

<Flex>
    <GridFieldValue field={workerField}>
        <KpUserAvatar userRecordId={workerField?.originRecordReference?.id} sizePx={32}/>
        <span class="username">{getTextFromGridFieldValue(workerField)}</span>
    </GridFieldValue>
</Flex>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";

    .username {
        font-size: @font-size-xl;
    }
</style>